"use strict";

var _interopRequireDefault = require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _api = require("../api/api");
var _default = exports.default = {
  // 使用时请使用 :url.sync=""传值
  props: {
    url: {
      required: true
    },
    side_bind: {
      type: String
    },
    ammId: {
      required: false
    },
    sourceType: {
      type: String
    },
    releaseTime: {
      type: String
    }
  },
  data: function data() {
    return {
      loading: false,
      html: ''
    };
  },
  watch: {
    url: function url(value) {
      this.load(value);
    }
  },
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this = this;
      var that;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            that = this;
            _context.next = 3;
            return this.load(this.url);
          case 3:
            setTimeout(function () {
              _this.hasRoll();
              //阻止a标签的默认事件，重新判断是否需要跳转
              // var aLink = document.getElementsByTagName("a");
              var aLink = document.getElementsByClassName("nd_article")[0].getElementsByTagName("a");
              for (var i = 0; i < aLink.length; i++) {
                var aDom = aLink[i];
                aDom.onclick = function (e) {
                  //阻止默认事件
                  if (e && e.preventDefault) {
                    e.preventDefault(); //W3C
                  } else {
                    window.event.returnValue = false; //IE
                  }
                  //处理跳转
                  var link = e.currentTarget.href;
                  that.jump(link);
                };
              }
            }, 500);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  methods: {
    load: function load(url) {
      var _this2 = this;
      if (url && url.length > 0) {
        // 加载中
        this.loading = true;
        var param = {
          accept: 'text/html, text/plain'
        };
        this.$http.get(url, param).then(function (response) {
          _this2.loading = false;
          // console.log('htmlpanel-responsedata',response.data)
          // 处理HTML显示：非自发的 或 自发时间大于一年的去掉图片，防止侵权
          var releaseTimeStr = _this2.releaseTime.replace(/\-/g, "/");
          var releaseTimeTsp = new Date(releaseTimeStr).getTime(); //把发布时间字符串转为时间戳
          var nowTimeTsp = new Date().getTime(); //当前时间戳
          var timeDiffrence = nowTimeTsp - releaseTimeTsp; //时间差
          console.log('htmlpanel-timeDiffrence', timeDiffrence);
          if (_this2.sourceType != 'ARTIFICIAL_RELEASE' || timeDiffrence > 365 * 24 * 60 * 60 * 1000) {
            var noImgHtml = response.data.replace(/<img.*?>/g, '');
            _this2.html = noImgHtml;
          } else {
            _this2.html = response.data;
          }
        }).catch(function () {
          _this2.loading = false;
          _this2.html = '加载失败';
        });
      }
    },
    hasRoll: function hasRoll() {
      var that = this;
      var pscrollHeight = document.getElementById(that.side_bind).scrollHeight;
      var pclientHeight = document.getElementById(that.side_bind).clientHeight;
      console.log(pscrollHeight);
      console.log(pclientHeight);
      this.$emit('setLookAll', pscrollHeight);
      //  console.log(that.hasScrollbar)
    },
    //判断是否可跳转
    jump: function () {
      var _jump = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(link) {
        var that, params, param, _yield$apiGetNewsUrlJ, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              that = this;
              params = {
                version: "1",
                fun: "checkUrlJump",
                param: {
                  ammId: that.ammId,
                  url: link
                }
              };
              param = {
                jsonParamete: JSON.stringify(params)
              };
              _context2.next = 5;
              return (0, _api.apiGetNewsUrlJump)(param);
            case 5:
              _yield$apiGetNewsUrlJ = _context2.sent;
              data = _yield$apiGetNewsUrlJ.data;
              if (data.proData == true) {
                //跳转：新开页面
                window.open(link, "_blank");
                console.log('jump');
              } else {
                //不跳转
              }
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function jump(_x) {
        return _jump.apply(this, arguments);
      }
      return jump;
    }()
  }
};